import i18n from 'modules/core/lib/i18n'

export type LaborCostType = 'company_cost' | 'simple_calculation'

export const LABOR_COST_TYPES = {
  COMPANY_COST: 'company_cost',
  SIMPLE_CALCULATION: 'simple_calculation',
} as const

export const LABOR_COST_CONCEPT_CALCULATION_TYPES = {
  ADD_TO_TOTAL: 'add_to_total',
  SUBTRACT_FROM_TOTAL: 'subtract_from_total',
} as const

export interface FinancialWorkspaceSettingsFormValues {
  laborCostType: LaborCostType
  conceptIdsToAdd: number[]
  conceptIdsToSubtract: number[]
  subtractEmployeeExpenses: boolean
}

export const SOURCE_OF_TRUTH_OPTIONS = () => [
  {
    value: LABOR_COST_TYPES.COMPANY_COST,
    label: i18n.t(
      'finance.financial_workspace.settings.labor_cost.source_of_truth_options.concept'
    ),
  },
  {
    value: LABOR_COST_TYPES.SIMPLE_CALCULATION,
    label: i18n.t(
      'finance.financial_workspace.settings.labor_cost.source_of_truth_options.simple_calculation'
    ),
  },
]
